import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import Moment from 'moment';
import Zoom from 'react-medium-image-zoom';

const ProgressPhotosCard = ({ progressPhotos, progressPhotoAngles, get }) => {
    if (!progressPhotos || !progressPhotos.length) {
        return <div>No available progress photo</div>;
    }

    return (
        <>
            {progressPhotos.map((v, vIndex) => {
                const photoExist = v.photo_left || v.photo_front || v.photo_right;
                return (
                    <Grid container key={`progress-photos-${vIndex}`}>
                        <Grid item xs={12}>
                            <Typography variant="body1">
                                Aligner Set #{v.aligner_number} {v.thickness}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                {photoExist ? (
                                    progressPhotoAngles.map((angle, angleIndex) => (
                                        <Grid
                                            key={`progress-photo-angles-${angleIndex}`}
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            style={{ padding: 8, textAlign: 'center' }}
                                        >
                                            <Typography>{String.toCapitalLetter(angle)} side</Typography>
                                            {v[`photo_${angle}`] && v[`photo_${angle}`].length ? (
                                                <>
                                                    <Typography>
                                                        {get('modals.uploadedAt')} :{' '}
                                                        {v[`photo_${angle}_date`]
                                                            ? Moment(v[`photo_${angle}_date`]).format(
                                                                  'DD MM YYYY HH:mm'
                                                              )
                                                            : 'N/A'}
                                                    </Typography>
                                                    <Zoom zoomMargin={48}>
                                                        <img
                                                            src={v[`photo_${angle}`]}
                                                            style={{
                                                                maxHeight: 300,
                                                                width: 'auto',
                                                                marginLeft: 'auto',
                                                                marginRight: 'auto',
                                                                maxWidth: '100%',
                                                            }}
                                                        />
                                                    </Zoom>
                                                </>
                                            ) : (
                                                <div>Not uploaded yet</div>
                                            )}
                                        </Grid>
                                    ))
                                ) : (
                                    <div>No available progress photo</div>
                                )}
                            </Grid>
                            <hr />
                        </Grid>
                    </Grid>
                );
            })}
        </>
    );
};

export default ProgressPhotosCard;
